<!-- Vue component -->
<template>
  <div id="multiselect">
    <multiselect v-model="value"
      :multiple="true"
      :options="options"
      :close-on-select="false"
      :clear-on-select="false"
      :placeholder="placeholder"
      label="name"
      track-by="name"
      :preselect-first="false"
      @input="update">
    </multiselect>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  components: {
    Multiselect,
  },
  props: {
    placeholder: {type: String, default: ""},
    options: {type: Array, default: () => []},
  },
  data() {
    return {
      value: [],
    };
  },
  methods: {
    update() {
      this.$emit("update", this.value);
    },
  },
};
</script>

<!-- New step!
     Add Multiselect CSS. Can be added as a static asset or inside a component. -->
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.multiselect__option--highlight {
  background: rgb(102, 204, 102);
}

.multiselect__option--highlight:after {
  background: rgb(102, 204, 102);
}
.multiselect__option--selected.multiselect__option--highlight:after {
  background: #f3f3f3;
  color: #35495e;
}
.multiselect__option--selected.multiselect__option--highlight {
  background: #f3f3f3;
  color: #35495e;
}
.multiselect__tag {
  background: rgb(102, 204, 102);
}
</style>